import OrderedListMenu from './ordered-list-menu';
export default OrderedListMenu;
